<template functional>
  <div
    :class="['image']"
    :style="{
      width: `${props.imageWidth / 50}rem`,
      height: `${props.imageWidth / 50}rem`
    }"
  >
    <component
      :is="injections.components.GoodImage"
      :img-url="props.imgUrl | ossHttpVersion"
      :width="`${props.imageWidth / 50}rem`"
      :height="`${props.imageWidth / 50}rem`"
      :mode="'cover'"
    />
    <img
      v-if="props.isVideo"
      class="video-pic"
      src="../../../../src/images/cms/goods/play.png"
    />
    <img
      v-for="(pic, index) in props.promoteTagPic"
      :key="index"
      class="promote-tag-pic"
      :src="pic"
    />
    <div
      :class="props.stockStatus ? 'mask' : ''"
      :style="{
        width: `${props.imageWidth / 50}rem`,
        height: `${props.imageWidth / 50}rem`
      }"
    >
      <div v-if="props.stockStatus" :class="['goods-status', props.type]">
        <div class="status-text">{{ props.stockStatus }}</div>
      </div>
    </div>
    <div
      v-if="props.sortIndex != 0"
      :class="[
        'sort-image',
        props.sortIndex > 0 && props.sortIndex <= 3
          ? 'sort-image-number-' + props.sortIndex
          : ''
      ]"
    >
      {{ props.sortIndex }}
      <div
        :class="[
          'triangle',
          props.sortIndex > 0 && props.sortIndex <= 3
            ? 'triangle-number-' + props.sortIndex
            : ''
        ]"
      ></div>
    </div>
  </div>
</template>

<script>
import GoodImage from '@/common/widget/GoodImage/index.vue'
export default {
  inject: {
    components: {
      default: {
        GoodImage
      }
    }
  },
  props: {
    imgUrl: {
      type: String,
      default: ''
    },
    imageWidth: {
      type: Number,
      default: 0
    },
    promoteTagPic: {
      type: Array,
      default: () => []
    },
    borderWithRadius: {
      type: Boolean,
      default: false
    },
    stockStatus: {
      type: String,
      default: ''
    },
    // 热销榜图片左上角排序
    sortIndex: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: ''
    },
    isVideo: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  background-color: rgba(255, 255, 255, 0.6);
}
.image {
  position: relative;

  overflow: hidden;

  border-radius: 0.08rem;

  flex: none;
  .video-pic {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    width: 0.72rem;
    height: 0.72rem;
  }
  .promote-tag-pic {
    position: absolute;

    top: 0;
    left: 0;
    z-index: 2;

    width: 100%;
    height: 100%;
  }
  .goods-status {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 2;
    transform: translate(-50%, -50%);

    width: 1.44rem;
    padding: 0.08rem 0 0.08rem 0;

    background-color: rgba(0, 0, 0, 0.45);
    border-radius: 0.08rem;

    font-size: 0.24rem;
    text-align: center;
    color: #fff;
    box-sizing: border-box;
    .status-text {
      @include text-overflow-ellipsis-multiple;
    }
    &.sole-good-remind {
      width: 1.16rem;
      padding: 0.08rem 0 0.08rem 0;

      font-size: 0.2rem;
    }
  }
}
.sort-image {
  position: absolute;

  top: 0;
  left: 0;

  width: 0.42rem;
  height: 0.42rem;

  background-color: #59df7c;

  font-size: 0.3rem;
  line-height: 0.48rem;
  text-align: center;
  color: #fff;
  // 底部三角形
  & .triangle {
    position: absolute;
    top: 0.42rem;

    width: 0;
    height: 0;

    border-right: 0.21rem solid #59df7c;
    border-bottom: 0.08rem solid transparent;
    border-left: 0.21rem solid #59df7c;
  }
  & .triangle-number-1 {
    border-right: 0.21rem solid #f45e33;
    border-left: 0.21rem solid #f45e33;
  }
  & .triangle-number-2 {
    border-right: 0.21rem solid #f88e31;
    border-left: 0.21rem solid #f88e31;
  }
  & .triangle-number-3 {
    border-right: 0.21rem solid #fec04f;
    border-left: 0.21rem solid #fec04f;
  }
}
.sort-image-number-1 {
  background-color: #f45e33;
}
.sort-image-number-2 {
  background-color: #f88e31;
}
.sort-image-number-3 {
  background-color: #fec04f;
}
</style>
